var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image_attachment"},[_c('img',{attrs:{"src":(_vm.api_url + "/messages/attachment/" + (_vm.attachment._id)),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }